/* JOLI POT, petit lien « Partager » (assets/jp-partage.js, 23/10/2026 ; 25/10 : rond sur la photo des fiches produit). Réglages : #jp-partage-cfg, écrit par snippets/jp-partage.liquid.
   Mobile (écran tactile, navigator.share disponible) : partage natif (titre + adresse propre). Sinon : petit menu
   Copier le lien, WhatsApp, Pinterest, Facebook, E-mail. Menu accessible : bouton à état aria-expanded, Échap et clic ailleurs ferment,
   le focus revient sur le bouton, annonce « Lien copié » pour les lecteurs d'écran. Aucun script tiers. */
(function () {
  var cfgEl = document.getElementById('jp-partage-cfg');
  if (!cfgEl || document.querySelector('[data-jp-partage]')) return;
  var C = {};
  try { C = JSON.parse(cfgEl.textContent); } catch (e) { return; }
  var url = String(C.url || location.origin + location.pathname).split('?')[0].split('#')[0];
  var titre = C.titre || document.title;
  var e = encodeURIComponent;
  var SVG = function (d) { return '<svg class="jpps__ico" viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">' + d + '</svg>'; };
  var ICO = {
    partager: '<path d="M12 3.5v11"/><path d="M8.2 7.2 12 3.5l3.8 3.7"/><path d="M6.5 11H5v9h14v-9h-1.5"/>',
    lien: '<path d="M10.2 13.8a3.6 3.6 0 0 0 5.1 0l3-3a3.6 3.6 0 0 0-5.1-5.1l-1 1"/><path d="M13.8 10.2a3.6 3.6 0 0 0-5.1 0l-3 3a3.6 3.6 0 0 0 5.1 5.1l1-1"/>',
    whatsapp: '<path d="M4.6 19.6 5.8 16A7.8 7.8 0 1 1 8.4 18.4Z"/><path d="M9.3 9.2c.3 1.9 1.6 3.4 3.6 4.1l1-.9 1.5.8"/>',
    pinterest: '<circle cx="12" cy="12" r="8.5"/><path d="M11 20.3l1.7-7.3"/><path d="M10.4 15.4c3.3.7 5.4-1.2 5.4-3.8 0-2.3-1.9-3.9-4.1-3.9-2.6 0-4.2 1.9-4.2 3.8 0 .9.3 1.6.9 2"/>',
    facebook: '<path d="M14.6 4.5h-1.8a3 3 0 0 0-3 3v13"/><path d="M7.5 11.2h6.6"/>',
    email: '<path d="M3.5 6.5h17v11h-17z"/><path d="m3.5 6.5 8.5 6.4 8.5-6.4"/>'
  };
  var liens = [
    { cle: 'whatsapp', nom: 'WhatsApp', href: 'https://wa.me/?text=' + e(titre + ' ' + url) },
    { cle: 'pinterest', nom: 'Pinterest', href: 'https://www.pinterest.com/pin/create/button/?url=' + e(url) + (C.image ? '&media=' + e(C.image) : '') + '&description=' + e(titre) },
    { cle: 'facebook', nom: 'Facebook', href: 'https://www.facebook.com/sharer/sharer.php?u=' + e(url) },
    { cle: 'email', nom: 'E-mail', href: 'mailto:?subject=' + e(C.objet || titre) + '&body=' + e(titre + '\n' + url), meme: true }
  ];
  var n = 0;
  function creer() {
    var id = 'jpps-menu-' + (++n);
    var w = document.createElement('div');
    w.className = 'jpps jpps--' + (C.type || 'produit');
    w.setAttribute('data-jp-partage', '');
    var h = '<button type="button" class="jpps__btn" aria-expanded="false" aria-controls="' + id + '">' + SVG(ICO.partager) + '<span>' + esc(C.libelle || 'Partager') + '</span></button>'
      + '<div class="jpps__menu" id="' + id + '" role="group" aria-label="' + esc(C.menu || 'Partager cette page') + '" hidden><ul class="jpps__liste" role="list">'
      + '<li><button type="button" class="jpps__item" data-jpps="copier">' + SVG(ICO.lien) + '<span>' + esc(C.copier || 'Copier le lien') + '</span></button></li>';
    liens.forEach(function (l) {
      h += '<li><a class="jpps__item" data-jpps="' + l.cle + '" href="' + esc(l.href) + '"' + (l.meme ? '' : ' target="_blank" rel="noopener noreferrer"') + '>' + SVG(ICO[l.cle]) + '<span>' + l.nom + '</span>' + (l.meme ? '' : '<span class="jpps__sr"> (nouvel onglet)</span>') + '</a></li>';
    });
    h += '</ul><p class="jpps__ok" role="status" aria-live="polite"></p></div>';
    w.innerHTML = h;
    brancher(w);
    return w;
  }
  function esc(t) { return String(t).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function tactile() { return !!(navigator.share && window.matchMedia && matchMedia('(hover: none) and (pointer: coarse)').matches); }
  function brancher(w) {
    var btn = w.querySelector('.jpps__btn'), menu = w.querySelector('.jpps__menu'), ok = w.querySelector('.jpps__ok');
    function ouvrir(oui) {
      menu.hidden = !oui;
      btn.setAttribute('aria-expanded', oui ? 'true' : 'false');
      w.classList.toggle('is-ouvert', oui);
      if (oui) {
        ok.textContent = '';
        /* Le menu reste dans l'écran (décalage horizontal si besoin) */
        menu.style.transform = '';
        var r = menu.getBoundingClientRect(), dx = 0;
        if (r.right > window.innerWidth - 8) dx = window.innerWidth - 8 - r.right;
        if (r.left + dx < 8) dx = 8 - r.left;
        if (dx) menu.style.transform = 'translateX(' + Math.round(dx) + 'px)';
        var p = menu.querySelector('.jpps__item'); if (p) p.focus();
      }
    }
    btn.addEventListener('click', function () {
      if (tactile()) {
        navigator.share({ title: titre, url: url }).catch(function (er) { if (!er || er.name !== 'AbortError') ouvrir(true); });
        return;
      }
      ouvrir(menu.hidden);
    });
    w.querySelector('[data-jpps="copier"]').addEventListener('click', function () {
      var fini = function () { ok.textContent = C.copie || 'Lien copié'; w.classList.add('is-copie'); setTimeout(function () { w.classList.remove('is-copie'); }, 2200); };
      var secours = function () {
        var t = document.createElement('textarea'); t.value = url; t.setAttribute('readonly', ''); t.style.cssText = 'position:fixed;top:0;left:0;opacity:0';
        document.body.appendChild(t); t.select();
        try { document.execCommand('copy'); fini(); } catch (er) { ok.textContent = url; }
        t.remove();
      };
      if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(url).then(fini, secours); else secours();
    });
    w.addEventListener('keydown', function (ev) { if (ev.key === 'Escape' && !menu.hidden) { ouvrir(false); btn.focus(); } });
    document.addEventListener('click', function (ev) { if (!menu.hidden && !w.contains(ev.target)) ouvrir(false); });
    w.addEventListener('focusout', function (ev) { if (!menu.hidden && ev.relatedTarget && !w.contains(ev.relatedTarget)) ouvrir(false); });
  }

  /* Placement */
  function poserProduit() {
    /* 25/10/2026 : sur les fiches produit, le partage devient un petit rond en pointillés posé en haut à droite de la grande photo
       (picto seul, mini tampon « Partager » au survol). Le bloc « Partager » natif de Prestige reste masqué. */
    var natifs = document.querySelectorAll('.product-info share-button');
    natifs.forEach(function (s) { var b = s.closest('.product-info__block-item') || s; b.classList.add('jpps-natif'); });
    var w = creer();
    var cadre = document.querySelector('main .product-gallery');
    if (!cadre) cadre = photoHero() || grandePhoto(false);
    if (cadre) {
      if (getComputedStyle(cadre).position === 'static') cadre.style.position = 'relative';
      w.classList.add('jpps--photo');
      cadre.appendChild(w);
      return;
    }
    var t = document.querySelector('.product-info h1, main h1');
    if (t) { w.classList.add('jpps--sous'); t.insertAdjacentElement('afterend', w); return; }
    var n0 = natifs[0]; if (n0) n0.parentNode.insertBefore(w, n0);
  }
  /* Première grande photo de la page (bannière d'une page d'occasion, photo d'une fiche au format libre) ; haut = seulement en haut de page */
  function grandePhoto(haut) {
    var imgs = document.querySelectorAll('main img'), i, im, r, c;
    for (i = 0; i < imgs.length; i++) {
      im = imgs[i]; r = im.getBoundingClientRect();
      if (r.width < 240 || r.height < 200 || im.closest('.jpav, .jpmm, footer, .jpps, [class*="carte"], [class*="card"], [hidden]')) continue;
      if (haut && r.top + window.scrollY > window.innerHeight * 1.6) return null;
      c = im.parentElement; if (c && c.tagName === 'PICTURE') c = c.parentElement;
      return c;
    }
    return null;
  }
  /* 27/10/2026 : photo du haut des pages d'occasion, Entreprise et Événement trouvée directement (avant : mesure de toutes les images de la page) */
  function photoHero() {
    var im = document.querySelector('main .jpe-hero__img'); if (!im) return null;
    var c = im.parentElement; if (c && c.tagName === 'PICTURE') c = c.parentElement;
    return c;
  }
  /* 25/10/2026 : pages d'occasion (collections avec modèle), même petit rond en haut à droite de la photo à la une */
  function poserCollection() {
    var cadre = photoHero() || grandePhoto(true);
    if (!cadre) return;
    var w = creer();
    if (getComputedStyle(cadre).position === 'static') cadre.style.position = 'relative';
    w.classList.add('jpps--photo');
    cadre.appendChild(w);
  }
  function poserArticle() {
    var w = creer(), zone = document.querySelector('.jpa__partage');
    if (zone) { zone.innerHTML = ''; zone.classList.add('jpps-zone'); zone.appendChild(w); return; }
    var art = document.querySelector('main article, .jpa__article');
    if (art) { w.classList.add('jpps--sous'); art.appendChild(w); }
  }
  function poser() { if (document.querySelector('[data-jp-partage]')) return; if (C.type === 'article') poserArticle(); else if (C.type === 'collection') poserCollection(); else poserProduit(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', poser); else poser();
})();
